export const isSafariBrowser = () => {
  if (typeof navigator === 'undefined' || !navigator.userAgent) return false;
  const ua = navigator.userAgent;
  // Exclude Chromium-based browsers
  return /Safari/i.test(ua) && !/Chrome|CriOS|Edg|Android/i.test(ua);
};

let cachedSupportsBookViewer: boolean | undefined;

/**
 * Detects whether the browser can render pdf books with pdf.js.
 *
 * Book viewer uses pdf.js v5, which uses syntax Safari only shipped in 16.4
 * We feature-detect that 16.4 boundary with a RegExp lookbehind assertion,
 * which Safari also added in 16.4. Building it from a string keeps the
 * unsupported syntax out of our own (transpiled) bundle and defers the parse
 * to runtime, so pre-16.4 engines throw a real SyntaxError here.
 *
 * @returns true when the browser can parse the modern syntax pdf.js relies on.
 */
export const isBookViewerSupported = () => {
  if (cachedSupportsBookViewer !== undefined) return cachedSupportsBookViewer;

  try {
    new RegExp('(?<=a)b');
    cachedSupportsBookViewer = true;
  } catch {
    cachedSupportsBookViewer = false;
  }

  return cachedSupportsBookViewer;
};

/**
 * Finds the scrollable container by walking up the DOM tree and scrolls to the top.
 * Useful for scrolling to the top of a modal/dialog when validation fails.
 */
export const scrollToTopOfScrollableContainer = (startElement: Element | null) => {
  if (!startElement) return;

  // Find the scrollable container by walking up the DOM tree
  let scrollableContainer: Element | null = startElement;
  while (scrollableContainer && scrollableContainer !== document.body) {
    const style = window.getComputedStyle(scrollableContainer);
    const isScrollable = style.overflowY === 'auto' || style.overflowY === 'scroll';
    const hasScroll = scrollableContainer.scrollHeight > scrollableContainer.clientHeight;

    if (isScrollable && hasScroll) {
      break;
    }
    scrollableContainer = scrollableContainer.parentElement;
  }

  if (scrollableContainer && scrollableContainer !== document.body) {
    scrollableContainer.scrollTo({ top: 0, behavior: 'smooth' });
  }
};
